import React from "react";
import type { ActionTone } from "../types";

const SummaryStat = ({
  icon: Icon,
  value,
  label,
  tone = "info",
}: {
  icon: any;
  value: React.ReactNode;
  label: React.ReactNode;
  tone?: ActionTone;
}) => (
  <div className={`pp-actions-summary-stat is-${tone}`}>
    <span className="pp-actions-summary-icon" aria-hidden="true">
      <Icon />
    </span>
    <span className="pp-actions-summary-copy">
      <span className="pp-actions-summary-value">{value}</span>
      <span className="pp-actions-summary-label">{label}</span>
    </span>
  </div>
);



export default SummaryStat;
